(() => {
  'use strict';
  const root = document.querySelector('[data-pl-relay-page]');
  if (!root) return;
  const status = root.querySelector('[role="status"]');
  root.querySelectorAll('[data-postcode]').forEach(button => {
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(button.dataset.postcode);
        status.textContent = `Code postal ${button.dataset.postcode} copié. Collez-le dans le localisateur GLS, pays France.`;
      } catch (_) {
        status.textContent = `À saisir dans le localisateur GLS : ${button.dataset.postcode}, France.`;
      }
    });
  });
})();
